export default {
  data() {
    return {
      holidayData: [], //节假日时间
    };
  },
  methods: {
    //获取节假日权限类型
    getHolidayType(type, param, flg) {
      let params = false;
      let holidayRuleList = [];
      if (localStorage.getItem(param)) {
        let config = JSON.parse(localStorage.getItem(param));
        if (flg) {
          //缓存的是bizParam
          holidayRuleList = config.holidayRuleList;
        } else {
          holidayRuleList = config.bizParam.holidayRuleList;
        }
      }
      if (holidayRuleList.length > 0) {
        holidayRuleList.forEach((i) => {
          if (type == i.type) {
            params = i.isCheckHoliday;
          }
        });
      }

      return params;
    },
    // 获取节假日时间
    getHoliday(date1, date2, flg) {
      console.log("getHoliday", flg);

      let param = {
        holidayYears: [],
      };
      let start = date1 ? date1.substr(0, 4) : new Date().getYear();
      let end = date2 ? date2.substr(0, 4) : new Date().getYear();
      if (start == end) {
        param.holidayYears = [start];
      } else {
        //跨年了
        param.holidayYears = [start, end];
      }
      if (
        localStorage.getItem("holidayYears") &&
        localStorage.holidayYears == JSON.stringify(param.holidayYears)
      ) {
        return;
      } else {
        localStorage.holidayYears = JSON.stringify(param.holidayYears);
      }
      return new Promise((resolve, reject) => {
        this.api
          .postJson(`/${serverConfig.msConfigureService}/holiday/list`, param)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let { data } = res.data;
              this.holidayData = data;
              if (flg) {
                this.getVisitTime(date1, flg);
              }
            }
          });
      });
    },
    //判断是否节假日
    matchDate(day) {
      if (!day) return;
      day = new Date(day);
      const year = day.getFullYear();
      const month = day.getMonth() + 1;
      const date = day.getDate();
      let isHoliday = false;
      this.holidayData.forEach((item) => {
        let yearTask = new Date(item.holidayDate).getFullYear();
        let monthTask = new Date(item.holidayDate).getMonth() + 1;
        let dateTask = new Date(item.holidayDate).getDate();
        if (
          year === yearTask &&
          month === monthTask &&
          date === dateTask &&
          item.isLegalHoliday == "Y"
        ) {
          isHoliday = true;
        }
      });

      return isHoliday;
    },
    getVisitTime(res, formData, param, callback) {
      if (this.matchDate(res)) {
        if (this.isIntercept) {
          this.$message.error("节假日不可选择，请更换日期！");
          if (param) {
            console.log("1");
            this.$set(formData, param, null);
          } else {
            console.log("2");
            // this.$set(formData,null)
            formData = null;
          }
        } else {
          this.$confirm("您选择的是国家法定节假日，确定选择吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then((action) => {
              // res = res
              if (param) {
                console.log("3");
                this.$set(formData, param, res);
              } else {
                console.log("4");
                // this.$set(formData,res)
                formData = res;
              }
            })
            .catch(() => {
              // res = null
              if (param) {
                console.log("5");

                this.$set(formData, param, null);
              } else {
                console.log("6");
                this.$set(this, null);
                formData = null;
              }
            });
        }
      } else {
        // item = res
        if (param) {
          console.log("7");
          this.$set(formData, param, res);
        } else {
          console.log("8");
          // this.$set(formData,res)
          formData = res;
        }
      }
      if (callback) {
        console.log("000");

        callback();
      }
    },
  },
};
